import { getAppsyncUrl } from "../authenticate";
import { getAuth } from '../../contexts/authStore';

export async function getPositions(scheduleId: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `query Query {
                getPositions(scheduleId: ${JSON.stringify(scheduleId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getPositions)
            })
        })
    }
}

export async function putPosition(scheduleId: string, position: string, positionName: string, employees?: [string]) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                putPosition(scheduleId: ${JSON.stringify(scheduleId)}, position: ${JSON.stringify(position)}, positionName: ${JSON.stringify(positionName)}, employees: ${employees ? JSON.stringify(employees) : '[]'})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putPosition)
            })
        })
    }
}

export async function deletePosition(scheduleId: string, position: string) {
    if (getAuth().userId) {
        const token = getAuth().idToken;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                credentials: 'include',
                ...(token && { headers: { "Authorization": token } }),
                body: JSON.stringify({
                    query: `mutation Mutation {
                deletePosition(scheduleId: ${JSON.stringify(scheduleId)}, position: ${JSON.stringify(position)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deletePosition)
            })
        })
    }
}